export const CheckmarkIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#93CE95" />
        <path d="M14 24L21 31L34 18" stroke="#3C8B3F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);
